const constants = {
  authenticationModes: [
    {
      label: 'Card Only',
      value: 0,
      message: '',
      consentNeeded: false,
    },
    {
      label: 'Card + PIN',
      value: 1,
      message: 'PIN can be anywhere from 4-6 digits',
      consentNeeded: false,
    },
    {
      label: 'Card/User ID/Fingerprint',
      value: 2,
      message:
        'Please ensure your device has a fingerprint scanner. Your local regulations may require you to recieve biometric consent from your users prior to doing biometric authentication.',
      consentNeeded: true,
    },
    {
      label: 'Card/User ID + PIN',
      value: 3,
      message: 'PIN can be anywhere from 4-6 digits',
    },
    {
      label: 'Card/User ID + Fingerprint',
      value: 4,
      message:
        'Please ensure your device has a fingerprint scanner. Your local regulations may require you to recieve biometric consent from your users prior to doing biometric authentication.',
      consentNeeded: true,
    },
    {
      label: 'Card/User ID + Fingerprint (PIN Fallback)',
      value: 6,
      message:
        'This is a special fallback mode. If a user cannot enroll a fingerprint, they can authenticate via a PIN. Set this mode after all enrollments (PIN and Finger) for users are complete.',
      consentNeeded: true,
    },
    {
      label: 'Fingerprint Only',
      value: 5,
      message:
        'Please ensure your device has a fingerprint scanner. Your local regulations may require you to recieve biometric consent from your users prior to doing biometric authentication.',
      consentNeeded: true,
    },
  ],
  twoPersonAuthModes: [
    {
      label: 'Any Two Users',
      value: 'DEFAULT',
      message: '',
    },
    {
      label: 'Must Include One Group Admin',
      value: 'ONE_ADMIN',
      message: '',
    },
  ],
  actionNotAvailableMessage: 'Action not available for User Permission Level',
  twoCredentialAuthTimeout: 60,
  accessEventAccessModeType: [
    {
      label: 'Unknown',
      value: 'Unknown',
    },
    {
      label: 'Access Request',
      value: 'AccessRequest',
    },
    {
      label: 'Two Credential Authentication',
      value: 'MultiParty',
    },
    {
      label: 'Two Credential Authentication',
      value: 'MultiPartyAccessRequest',
    },
    {
      label: 'Remotely Authorized',
      value: 'Otp',
    },
    {
      label: 'Forced Open',
      value: 'ForcedOpen',
    },
  ],
  transactionCredentialType: [
    {
      label: 'Unknown',
      value: 'Unknown',
    },
    {
      label: 'Card',
      value: 'Card',
    },
    {
      label: 'User ID',
      value: 'UserId',
    },
    {
      label: 'PIN',
      value: 'Pin',
    },
    {
      label: 'Fingerprint',
      value: 'Fingerprint',
    },
    {
      label: 'Mobile',
      value: 'StepUp',
    },
    {
      label: 'Card + PIN',
      value: 'CardPin',
    },
    {
      label: 'User ID + PIN',
      value: 'UserIdPin',
    },
    {
      label: 'Card + Fingerprint',
      value: 'CardFingerprint',
    },
    {
      label: 'User ID + Fingerprint',
      value: 'UserIdFingerprint',
    },
    {
      label: 'Card + Fingerprint (fallback)',
      value: 'CardPinFallback',
    },
    {
      label: 'User ID + Fingerprint (fallback)',
      value: 'UserIdPinFallback',
    },
  ],
  accessModeEnum: {
    Unknown: 'Unknown',
    AccessRequest: 'AccessRequest',
    MultiParty: 'MultiParty',
    MultiPartyAccessRequest: 'MultiPartyAccessRequest',
    Otp: 'Otp',
    ForcedOpen: 'ForcedOpen',
  },
  deviceEventTypeEnum: {
    DoorOpen: 'Door Opened',
    DoorClose: 'Door Closed',
    DoorHeldOpen: 'Door Held Open',
    DoorForcedOpen: 'Door Forced Open',
    Otp: 'OTP Generated',
    Enrollment: 'Enrollment',
  },
  deviceEvent: [
    {
      label: 'Door Opened',
      value: 'DoorOpen',
    },
    {
      label: 'Door Closed',
      value: 'DoorClose',
    },
    {
      label: 'Door Held Open',
      value: 'DoorHeldOpen',
    },
    {
      label: 'Door Forced Open',
      value: 'DoorForcedOpen',
    },
    {
      label: 'OTP Generated',
      value: 'Otp',
    },
    {
      label: 'Enrollment',
      value: 'Enrollment',
    },
  ],
  accessEventTypeEnum: {
    Transaction: 'Transaction',
    DeviceEvent: 'Device Event',
  },
  storageKeys: {
    AccessToken: 'token',
    Logout: 'logout',
    LastSessionActive: 'lastSessionActive',
  }
}

export default constants
